<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-if="filter_json_key" v-slot:filter_condition_options>
            <MonitorOptionSet 
                :option_set="option_set"
                @filter_data="filter_data" 
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :enable_table_label="true"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <span>
                        說明："--"標示，顯示該欄位無資料。 
                    </span>
                    <br>
                    <span>
                        此表使用之雨量值來自雷達降水估計(QPE)經雨量站修正後之產品，請謹慎使用。
                    </span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import cloneDeep from 'lodash/cloneDeep'
    import {
        TABLE_VALUE_TEXT_MAPPING,
        dot_color_mapping
    } from "../../../config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorOptionSet from "../monitor_option_set.vue"
    import QpeDatatable from "../qpe_datatable.vue"

	export default {
        name: 'child_area_rainfall_qpe',
        
        components: { 
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorOptionSet, 
            QpeDatatable
        },

        mixins: [monitor_mixin],

        props: {
            default_value: {
                type: Number,
                required: true,
            },

            option_local_storage_name: {
                type: String,
                required: true,
            },

            filter_json_key:{
                type: String,
            }
        },

        data() {
			return {
                header: [],
                table_data: [],
                error_text: '',

                // filter使用
                immutable_table_data: [],
                option_set: [],
                display_all_route: '全區',

                should_show_raw_html_header: [
                    '七級暴風圈警示',
                ],

                TABLE_VALUE_TEXT_MAPPING: TABLE_VALUE_TEXT_MAPPING
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },
        
        watch: {
            immutable_table_data() {
                if (this.immutable_table_data) {
                    this.init_option_set()
                    this.update_option_set_from_local_storage()
                }
            },
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = this.reconstruct_alert_content(this.sort_table_data(data));
                this.header = header;
            },

            init_option_set() {  
                let option_set_array = [
                    {current_option_value: this.display_all_route, json_key: this.filter_json_key, label: 'route'},
                ]

                option_set_array.forEach(item => {
                    if(!item.option_array || item.option_array.length == 1) {
                        item.option_array = this.table_data.map(item2 => {
                            return item2[item.json_key]
                        });
                        item.option_array = [item.current_option_value, ...new Set(item.option_array)]
                    }
                })
                this.option_set = option_set_array
            },
            
            filter_data(filtered_cond) {
                //曾經選過的區域下拉選單, 對照欄位名稱為 this.filter_json_key
                if (this.option_set[0].current_option_value != filtered_cond['route']) {
                    this.option_set[0].current_option_value = filtered_cond['route']
                }
                
                let compare_route
                filtered_cond['route'] === this.display_all_route ? compare_route = '' : compare_route = filtered_cond['route']
        
                let filtered_data = this.immutable_table_data.filter((item)=> {
                    return (
                        item[this.filter_json_key].includes(compare_route)
                    )
                })
                this.table_data = this.reconstruct_alert_content(this.sort_table_data(filtered_data))

                // 把目前選擇的 option 存起來
                localStorage.setItem(this.option_local_storage_name, JSON.stringify(filtered_cond))
            },
            
            sort_table_data(data) {
                // '七級暴風圈警示' 目前得知的回傳值是數字
                return data.sort((datum) => +datum['七級暴風圈警示'] ? -1 : 0);
            },

            reconstruct_alert_content(data) {
                return cloneDeep(data).map(datum => {
                    const be_concat_object = {}
                    this.should_show_raw_html_header.forEach(html_header => {
                        const dot_color = dot_color_mapping[datum[html_header]]
                        if(dot_color) {
                            be_concat_object[html_header] = [{
                                'html': `<span class="dot" style="background: ${dot_color}"/>`
                            }]
                        }
                    })
                    return Object.assign(datum, be_concat_object)
                })
            },
            
            update_option_set_from_local_storage() {
                const child_area_rainfall_qpe_option = JSON.parse(localStorage.getItem(this.option_local_storage_name))
                if (child_area_rainfall_qpe_option && Object.keys(child_area_rainfall_qpe_option).length !== 0) {
                    this.option_set[0].current_option_value = child_area_rainfall_qpe_option.route
                }
            },
        },

	}
</script>

<style>
</style>